import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cardTitle'
})
export class CardTitlePipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {}
}
